import React from "react";
import { Race } from "../../lib/types";

import { portraits } from "../../assets/images/races";
import GovernorateInfoLink from "./GovernorateInfoLink";
import { systemClass } from "../../lib/enums";

export enum InfoValue {
  TURNS = "Turn",
  GOLD = "Gold",
  WEAPONS = "Weapons",
  MANA = "Mana",
  MAGIC_ENERGY = "Magic Energy",
  POPS = "Pops",
  ATTACK = "Attack",
  DEFENCE = "Defence",
  CRIMES_LIMIT = "Crimes limit"
}

interface IProps {
  id?: number,
  name?: string,
  race?: Race,
  info: {[key: string]: string},
  setUpAction?: () => void,
  active: boolean
}

const EmperorTentBanner = ({
  id,
  name,
  race,
  info,
  setUpAction,
  active
}: IProps) => (
  <div className="col-sm-6 col-md-3 person-col" style={{ minWidth: "200px" }}>
    <div className={`person ${!id ? "disabled" : ""} ${systemClass.MatchHeight} ${active ? "selected" : ""}`}>
      {id && name && race ? <>
      <img
        src={portraits[race.name]}
        width={60}
        height={60}
        alt="governorate avatar"
        className="photo"
      />
        <h4 className="subname h3">
        <GovernorateInfoLink
        govId={id}
        name={name}
        raceName={race.name}
        />
        </h4>
      </> : <>
        <i className="icon-banner icon-xlg icon middle grey" style={{ height: "50px", width: "50px", marginBottom: "25px" }}/>
        <h4 className={"subname h3"}><span className="grey">EMPTY</span></h4>
      </>}
      <p>
        {Object.keys(info).map(key => <>
          <span className="white">{key}</span>&nbsp;&nbsp;<em>{info[key]}</em><br/>
        </>)}
      </p>
      {setUpAction && <a href="#"
          className="btn btn-blank"
          tabIndex={0}
          onClick={setUpAction}
      >
        Set Up
      </a>}
    </div>
  </div>
)

export default EmperorTentBanner;
